<template>
<div class="chapter">
<div class="inner_page">
<div class="body"><div class="chapter"><a id="page_8"></a><a id="p9000f1609970008001">
</a><h1 class="part-title">Day Time</h1><a id="page_9"></a><a id="p9000f1609960009001">
</a><div class="media-group"><img alt="" src="images/p9000f160g9001.png" width="39.20145%"/></div><img alt="" src="images/p9000f160g9002.png" width="37.74955%"/></div></div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ch006.vue?f42af630